import { render } from "./TicketView.vue?vue&type=template&id=8265bb22&scoped=true&ts=true"
import script from "./TicketView.vue?vue&type=script&lang=ts"
export * from "./TicketView.vue?vue&type=script&lang=ts"

import "./TicketView.vue?vue&type=style&index=0&id=8265bb22&scoped=true&lang=less"
import "./TicketView.vue?vue&type=style&index=1&id=8265bb22&lang=less"

import exportComponent from "/home/gitlab-runner/builds/LUZizzTB/0/unicorn/frontend/unicorn-fe-support/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8265bb22"]])

export default __exports__